import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ServerService } from './ServerService';

@Injectable({
  providedIn: 'root'
})
export class NfceService extends ServerService {

  constructor(http: HttpClient) {
    super(http);
  }

  // Alterado para aceitar o objeto de filtro
  liste(filtro?: any): Promise<any> {
    const params: any = {};

    if (filtro) {
      if (filtro.dataInicio) params.dataInicio = filtro.dataInicio;
      if (filtro.dataFim) params.dataFim = filtro.dataFim;
      if (filtro.status) params.status = filtro.status;
    }

    return this.obtenha('/nfce', params);
  }

  obtenhaDadosImpressao(id: number): Promise<any> {
    return this.obtenha(`/nfce/${id}/impressao`, {});
  }

  obtenhaProximasParaImpressao(): Promise<any> {
    return this.obtenha('/nfce/liste/nao-impressas', { });
  }

  marqueImpressa(nfce): Promise<any> {
    return this.facaPut('/nfce/'  + nfce.id + '/impressa', nfce);
  }

  enviarNota(nfceId: number): Promise<any> {
    return this.facaPost('/nfce/enviar', { id: nfceId });
  }

  cancelarNota(idNota: number, justificativa: string): Promise<any> {
    return this.facaPut('/nfce/cancelar', { idNota, justificativa });
  }

  obtenhaXmlNota(id: number): Promise<Blob> {
    return this.obtenhaArquivo(`/nfce/${id}/xml`, {});
  }

  obtenhaXmlDistribuicao(id: number): Promise<Blob> {
    return this.obtenhaArquivo(`/nfce/${id}/distribuicao`, {});
  }

  obtenhaZipNotas(filtro?: any): Promise<Blob> {
    return this.facaPostArquivo('/nfce/zip', { filtro: filtro || {} });
  }

  obtenha(url: string, params: any): Promise<any> {
    if (url.includes('/xml') || url.includes('/pdf')) {
      return this.obtenhaArquivo(url, params);
    }
    return super.obtenha(url, params);
  }

  reenvieNota(idNota: number): Promise<any> {
    return this.facaPost(`/nfce/reenviar/${idNota}`, {});
  }

  private obtenhaArquivo(url: string, params: any): Promise<Blob> {
    return new Promise((resolve, reject) => {
      this.http.get(url, { params, responseType: 'blob' })
        .subscribe(
          (response: Blob) => resolve(response),
          (error) => reject(error)
        );
    });
  }

  private facaPostArquivo(url: string, body: any): Promise<Blob> {
    return this.http.post(url, body, { responseType: 'blob', observe: 'response' })
      .toPromise()
      .then((response: HttpResponse<Blob>) => this.retorneBlobZipValido(response))
      .catch((error) => this.rejeiteErroDeDownload(error));
  }

  private async retorneBlobZipValido(response: HttpResponse<Blob>): Promise<Blob> {
    const blob = response.body;
    const contentType = (response.headers.get('content-type') || '').toLowerCase();

    if (!blob || !blob.size) {
      return Promise.reject('O ZIP retornado está vazio.');
    }

    if (contentType.includes('json') || contentType.includes('html') || !(await this.blobPareceZip(blob))) {
      return Promise.reject(await this.extraiaMensagemErroDoBlob(blob) || 'O servidor não retornou um arquivo ZIP válido.');
    }

    return blob;
  }

  private async rejeiteErroDeDownload(error: any): Promise<Blob> {
    const mensagem = error?.error instanceof Blob
      ? await this.extraiaMensagemErroDoBlob(error.error)
      : error?.message || error;

    return Promise.reject(mensagem || 'Erro ao baixar arquivo.');
  }

  private async blobPareceZip(blob: Blob): Promise<boolean> {
    const bytes = new Uint8Array(await blob.slice(0, 4).arrayBuffer());
    return bytes.length >= 4
      && bytes[0] === 0x50
      && bytes[1] === 0x4b
      && (
        (bytes[2] === 0x03 && bytes[3] === 0x04)
        || (bytes[2] === 0x05 && bytes[3] === 0x06)
        || (bytes[2] === 0x07 && bytes[3] === 0x08)
      );
  }

  private async extraiaMensagemErroDoBlob(blob: Blob): Promise<string> {
    const texto = await blob.text();

    if (!texto) {
      return '';
    }

    try {
      const resposta = JSON.parse(texto);
      return resposta?.erro || resposta?.message || texto;
    } catch (e) {
      return texto;
    }
  }
}
